import { ValidationErrorMessages } from '@constants/forms';
import { validatePostcode } from '@utils/validators';

import { FormErrors, FormValues } from './types';

const validate = (
  {
    postcode,
    manualEntry,
    buildingNumber,
    buildingName,
    thoroughfare,
    postTown,
    addressSelection,
  }: FormValues,
  formName: string,
  withAddressSelection = true
) => {
  const errors: FormErrors = {};

  if (!postcode) {
    errors.postcode = ValidationErrorMessages.POSTCODE_REQUIRED;
  } else if (!validatePostcode(postcode)) {
    errors.postcode = ValidationErrorMessages.INVALID_POSTCODE;
  }

  if (!manualEntry && !addressSelection && withAddressSelection) {
    errors.addressSelection = ValidationErrorMessages.NO_ADDRESS;
  }

  if (manualEntry) {
    if (!buildingNumber && !buildingName) {
      errors.buildingNumber = ValidationErrorMessages.FIELD_REQUIRED;
      errors.buildingName = ValidationErrorMessages.FIELD_REQUIRED;
    }

    if (!thoroughfare) {
      errors.thoroughfare = ValidationErrorMessages.FIELD_REQUIRED;
    }
    if (!postTown) {
      errors.postTown = ValidationErrorMessages.FIELD_REQUIRED;
    }
  }

  return Object.keys(errors).length > 0 ? { [formName]: errors } : {};
};

export { validate };
